import {defineField, defineType} from 'sanity'
import {MdOutlineAutoAwesomeMosaic} from 'react-icons/md'

export default defineType({
  name: 'featured-posts',
  title: 'Featured Posts',
  type: 'object',
  icon: MdOutlineAutoAwesomeMosaic,
  fields: [
    defineField({
      name: 'title',
      type: 'string',
      description: 'If empty, the default "Featured Articles" title will be used',
    }),
    defineField({
      name: 'posts',
      title: 'Posts',
      type: 'array',
      of: [{type: 'reference', to: [{type: 'blog.post'}]}],
    }),
  ],
  preview: {
    select: {
      title: 'title',
      posts: 'posts',
    },
    prepare({title, posts}) {
      return {
        title: title || 'Featured Articles',
        subtitle: posts.length > 0 ? `${posts.length} posts` : 'No posts',
      }
    },
  },
})
